export default __webpack_public_path__ + "static/media/shape3.72166672.svg";